// idb-keyval is used to persist the store in the IndexedDB
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserPermissionsStore {
  permissions: string[];
  groups: string[];
  modulos: string[];

  isLoading: boolean;
  isHydrated: boolean;

  setPermissions: (permissions: string[]) => void;
  setGroups: (groups: string[]) => void;
  setModulos: (modulos: string[]) => void;
  clear: () => void;
}

export const useUserPermissionsStore = create<UserPermissionsStore>()(
  persist(
    set => ({
      permissions: [],
      groups: [],
      modulos: [],
      isLoading: true,
      isHydrated: false,

      setPermissions: permissions => {
        set({ permissions });
      },
      setGroups: groups => {
        set({ groups });
      },
      setModulos: modulos => {
        set({ modulos });
      },
      clear: () => {
        set({ permissions: [], groups: [] });
      },
    }),

    {
      name: 'user-permissions',
      onRehydrateStorage: () => (state) => {
        if (state) state.isHydrated = true;
      },
    }
  )
);
